module.exports = __webpack_public_path__ + "img/jazz.8d0b7a8f.jpg";